import {
  FiAward, FiToggleRight, FiZap, FiBold, FiCreditCard, FiPlusCircle, FiPlus, FiXCircle, FiCompass, FiCopy, FiTag, FiPause, FiInbox, FiCheckSquare, FiEdit3, FiArchive, FiFolder, FiPhone, FiGitMerge, FiBookOpen, FiUploadCloud, FiGift, FiVolumeX, FiMusic, FiAlertTriangle, FiBox, FiUserCheck, FiSmile, FiShoppingCart, FiGlobe, FiShield, FiArrowRight, FiLink, FiAtSign, FiType, FiBarChart2, FiCornerUpLeft, FiThumbsUp, FiMousePointer, FiTrendingDown, FiDownload, FiSearch, FiChevronLeft, FiTv, FiRotateCcw, FiVideo, FiPackage, FiEyeOff, FiMessageSquare, FiPieChart, FiCheckCircle, FiHeart, FiActivity, FiSend, FiCode, FiAlertCircle, FiMic, FiBriefcase, FiMoreHorizontal, FiSettings, FiTrash2, FiCpu, FiTool, FiDollarSign, FiArrowDown, FiSmartphone, FiPaperclip, FiDatabase, FiHome, FiUserPlus, FiLoader, FiMapPin, FiUser, FiFile, FiMessageCircle, FiUsers, FiFileText, FiFeather, FiClock, FiBook, FiStar, FiMonitor, FiLayers, FiEdit2, FiPenTool, FiHash, FiArrowLeft, FiList, FiCircle, FiHelpCircle, FiTrendingUp, FiPlay, FiItalic, FiSun, FiImage, FiCoffee, FiServer, FiVolume2, FiInstagram, FiAlignLeft, FiLock, FiTarget, FiGrid, FiInfo, FiLinkedin, FiSave, FiYoutube, FiHardDrive, FiCamera, FiCalendar, FiMail, FiBell, FiChevronDown, FiEye, FiMoreVertical, FiColumns, FiFacebook, FiChevronRight, FiLayout, FiTwitter, FiThumbsDown, FiFilter, FiFlag, FiMicOff, FiUpload, FiMinus, FiBarChart, FiCheck, FiMap, FiToggleLeft, FiMoon, FiExternalLink, FiChevronUp, FiCornerUpRight, FiShare2, FiPercent, FiRefreshCw, FiMenu, FiEdit
} from 'react-icons/fi';
import {
  FaAddressCard, FaFacebook, FaGooglePlay, FaHeart, FaFileCsv, FaSnapchatGhost, FaLinkedin, FaWhatsapp, FaAmazon, FaEnvelopeOpenText, FaMap, FaLine, FaPaintBrush, FaYoutube, FaTelegramPlane, FaSnapchat, FaFlask, FaRocket, FaVideo, FaTwitter, FaInstagram, FaMobileAlt, FaImage, FaPhoneVolume, FaReddit, FaGlobeAmericas, FaGoogleDrive, FaFilePdf, FaGlobe, FaFileWord, FaCheckCircle, FaTiktok, FaHome, FaGoogle, FaBuilding, FaMicrosoft, FaMailchimp, FaSearchDollar, FaEnvelope, FaFileExcel, FaDropbox, FaTrophy, FaPinterest, FaDatabase, FaApple, FaBox, FaRedditAlien, FaFileAlt, FaSalesforce, FaSlack
} from 'react-icons/fa';
import {
  SiDropbox, SiCanvas, SiResend, SiWix, SiMailchimp, SiFacebook, SiGmail, SiReddit, SiHubspot, SiRoku, SiWordpress, SiPinterest, SiTiktok, SiInstagram, SiShopify, SiSnapchat, SiGoogle, SiYoutube, SiStripe, SiDatabricks
} from 'react-icons/si';
import {
  GiPointyHat
} from 'react-icons/gi';
import {
  BsMegaphone, BsPinAngleFill, BsPinAngle
} from 'react-icons/bs';

const allIcons = {
  BsMegaphone,
  BsPinAngle,
  BsPinAngleFill,
  FaAddressCard,
  FaAmazon,
  FaApple,
  FaBox,
  FaBuilding,
  FaCheckCircle,
  FaDatabase,
  FaDropbox,
  FaEnvelope,
  FaEnvelopeOpenText,
  FaFacebook,
  FaFileAlt,
  FaFileCsv,
  FaFileExcel,
  FaFilePdf,
  FaFileWord,
  FaFlask,
  FaGlobe,
  FaGlobeAmericas,
  FaGoogle,
  FaGoogleDrive,
  FaGooglePlay,
  FaHeart,
  FaHome,
  FaImage,
  FaInstagram,
  FaLine,
  FaLinkedin,
  FaMailchimp,
  FaMap,
  FaMicrosoft,
  FaMobileAlt,
  FaPaintBrush,
  FaPhoneVolume,
  FaPinterest,
  FaReddit,
  FaRedditAlien,
  FaRocket,
  FaSearchDollar,
  FaSnapchat,
  FaSnapchatGhost,
  FaTelegramPlane,
  FaTiktok,
  FaTrophy,
  FaTwitter,
  FaVideo,
  FaWhatsapp,
  FaYoutube,
  FiActivity,
  FiAlertCircle,
  FiAlertTriangle,
  FiAlignLeft,
  FiArchive,
  FiArrowDown,
  FiArrowLeft,
  FiArrowRight,
  FiAtSign,
  FiAward,
  FiBarChart,
  FiBarChart2,
  FiBell,
  FiBold,
  FiBook,
  FiBookOpen,
  FiBox,
  FiBriefcase,
  FiCalendar,
  FiCamera,
  FiCheck,
  FiCheckCircle,
  FiCheckSquare,
  FiChevronDown,
  FiChevronLeft,
  FiChevronRight,
  FiChevronUp,
  FiCircle,
  FiClock,
  FiCode,
  FiCoffee,
  FiColumns,
  FiCompass,
  FiCopy,
  FiCornerUpLeft,
  FiCornerUpRight,
  FiCpu,
  FiCreditCard,
  FiDatabase,
  FiDollarSign,
  FiDownload,
  FiEdit,
  FiEdit2,
  FiEdit3,
  FiExternalLink,
  FiEye,
  FiEyeOff,
  FiFacebook,
  FiFeather,
  FiFile,
  FiFileText,
  FiFilter,
  FiFlag,
  FiFolder,
  FiGift,
  FiGitMerge,
  FiGlobe,
  FiGrid,
  FiHardDrive,
  FiHash,
  FiHeart,
  FiHelpCircle,
  FiHome,
  FiImage,
  FiInbox,
  FiInfo,
  FiInstagram,
  FiItalic,
  FiLayers,
  FiLayout,
  FiLink,
  FiLinkedin,
  FiList,
  FiLoader,
  FiLock,
  FiMail,
  FiMap,
  FiMapPin,
  FiMenu,
  FiMessageCircle,
  FiMessageSquare,
  FiMic,
  FiMicOff,
  FiMinus,
  FiMonitor,
  FiMoon,
  FiMoreHorizontal,
  FiMoreVertical,
  FiMousePointer,
  FiMusic,
  FiPackage,
  FiPaperclip,
  FiPause,
  FiPenTool,
  FiPercent,
  FiPhone,
  FiPieChart,
  FiPlay,
  FiPlus,
  FiPlusCircle,
  FiRefreshCw,
  FiRotateCcw,
  FiSave,
  FiSearch,
  FiSend,
  FiServer,
  FiSettings,
  FiShare2,
  FiShield,
  FiShoppingCart,
  FiSmartphone,
  FiSmile,
  FiStar,
  FiSun,
  FiTag,
  FiTarget,
  FiThumbsDown,
  FiThumbsUp,
  FiToggleLeft,
  FiToggleRight,
  FiTool,
  FiTrash2,
  FiTrendingDown,
  FiTrendingUp,
  FiTv,
  FiTwitter,
  FiType,
  FiUpload,
  FiUploadCloud,
  FiUser,
  FiUserCheck,
  FiUserPlus,
  FiUsers,
  FiVideo,
  FiVolume2,
  FiVolumeX,
  FiXCircle,
  FiYoutube,
  FiZap,
  GiPointyHat,
  SiCanva: SiCanvas,
  SiDatabricks,
  SiDropbox,
  SiFacebook,
  SiGmail,
  SiGoogle,
  SiHubspot,
  SiInstagram,
  SiMailchimp,
  SiPinterest,
  SiReddit,
  SiResend,
  SiRoku,
  SiSalesforce: FaSalesforce,
  SiShopify,
  SiSlack: FaSlack,
  SiSnapchat,
  SiStripe,
  SiTiktok,
  SiWix,
  SiWordpress,
  SiYoutube
};

export const getIcon = (iconName) => {
  if (iconName === 'FaXTwitter') return FaTwitter;
  return allIcons[iconName] || FiAlertCircle;
};
